Ext.define('SA.view.menu.SetLocationAlias', {
    alias: 'widget.menu-set-location-alias',
    extend: 'Ext.menu.Item',

    beforeMenuShow() {
        this.refresh();
    },

    getLocation() {
        return this.location;
    },

    handler() {
        var location = SA.data.LocationsCache.get(this.getLocation(), this.handler, this);

        if (location) {
            Ext.widget({
                xtype: 'location-alias-window',
                location
            });
        }
    },

    refresh() {
        var locationId = this.getLocation(),
            location = SA.data.LocationsCache.get(locationId, this.refresh, this),
            isCustom = SA.data.LocationsCache.isCustomLocation(locationId);

        this.setVisible(!isCustom);
        this.setText(location && location.locationAlias ? 'Edit Alias Location Name' : 'Add Alias Location Name');
    }
});